import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ITarjeta } from './tarjeta';
import { map } from 'rxjs/operators';
import * as myGlobals from '../global';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class TarjetasService {
  private _tarjetasURL = myGlobals.baseApi + '/webadmin/v1/cardbrands';

  constructor(private http: HttpClientSecured) {}

  getTarjetas(): Observable<ITarjeta[]> {
    return this.http.get<ITarjeta[]>(this._tarjetasURL);
  }

  getTarjeta(id: number): Observable<ITarjeta | undefined> {
    return this.getTarjetas().pipe(map((tarjetas: ITarjeta[]) => tarjetas.find(p => p.id === id)));
  }
}
